import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const FONT = '"Barlow", "Roboto", "Helvetica", Arial, sans-serif';

// Copilot "−" next to a team's score: a plain yes/no before the team's latest
// saved goal is removed (OPUS-1635). Editing the goal lives on the score tile.
const RemoveGoalConfirmDialog = ({ open, teamName, onClose, onConfirm }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        backgroundColor: '#1E1E1E',
        borderRadius: 3,
        border: '1px solid rgba(255, 255, 255, 0.12)',
      },
    }}
  >
    <DialogTitle sx={{ color: '#FFFFFF', fontFamily: FONT, fontSize: 20, fontWeight: 600, pb: 1 }}>
      Remove Goal{teamName ? ` — ${teamName}` : ''}
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ color: '#FFFFFF', fontFamily: FONT, fontSize: 14, mt: 1 }}>
        Are you sure you would like to remove the saved goal?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        sx={{
          color: '#FFFFFF',
          fontFamily: FONT,
          textTransform: 'none',
          '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
        }}
      >
        No, cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        autoFocus
        sx={{
          backgroundColor: '#D1030D',
          color: '#FFFFFF',
          fontFamily: FONT,
          textTransform: 'none',
          fontWeight: 600,
          '&:hover': { backgroundColor: '#B0020A' },
        }}
      >
        Yes, remove
      </Button>
    </DialogActions>
  </Dialog>
);

RemoveGoalConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  teamName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default RemoveGoalConfirmDialog;
